import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination, EffectCoverflow } from 'swiper'

const body = document.querySelector('body');
const home = body.classList.contains('home');

function updateOpacity(swiper, slideSelector, endIndexCallback) {
    let slides = document.querySelectorAll(slideSelector);
    let activeIndex = swiper.activeIndex;
    let windowWidth = window.innerWidth;
    let endIndex = endIndexCallback(windowWidth, slides.length, activeIndex);

    slides.forEach(function (slide, index) {
        if (index >= activeIndex && index <= endIndex) {
            slide.style.opacity = '1';
            slide.style.pointerEvents = 'auto';
        } else {
            slide.style.opacity = '0.4';
            slide.style.pointerEvents = 'none';
        }
    });
}

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([ A11y, Autoplay, EffectFade, Navigation, Pagination ]);
        
        let config = {
            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Navigation (arrow)
            navigation: {
                nextEl: `.home-slideshow .swiper-button-next`,
                prevEl: `.home-slideshow .swiper-button-prev`,
            },

            // Pagination (bullet)
            pagination: {
                el: '.slideshow__pagination',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if(nbSlides > 1) {
            let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
        }
    }

    // slider Actualités
    const newsSlideshow = document.querySelector('.news .swiper-container') !== null;

    if (newsSlideshow) {
        let newsSlides = document.querySelectorAll('.news .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let newsConfig = {
            effect : 'slide',
            grabCursor : 'true',
            speed: 700,
            loop: false,

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                nextEl: `.news .swiper-button-next`,
                prevEl: `.news .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                1201: {
                    spaceBetween: 30, 
                    slidesPerView: 4, 
                },
        
                961: {
                    spaceBetween: 20, 
                    slidesPerView: 4,
                },
                
                641: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
        
                0: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                }
            }
        }

        let swiperNews = new Swiper('.news .swiper-container', newsConfig);

        // Fonction pour vérifier la taille de l'écran et le nombre de eventsSlides
        const postsNavigationNews = document.querySelector('.news__navigation');

        function checkScreenSizeNews() {
            const screenSizeNews = window.innerWidth;
            const newsSlides = document.querySelectorAll('.news .swiper-container .swiper-slide').length;

            if (screenSizeNews > 960 && newsSlides <= 4 ) {
                postsNavigationNews.classList.add('disable');
            } else if (screenSizeNews > 640 && newsSlides <= 3) {
                postsNavigationNews.classList.add('disable');
            } else if (screenSizeNews <= 640 && newsSlides <= 1) {
                postsNavigationNews.classList.add('disable');
            } else {
                postsNavigationNews.classList.remove('disable');
            }
        }

        checkScreenSizeNews();

        window.addEventListener('resize', checkScreenSizeNews);

        //Gestion de l'opacité des slides
        let newsEndIndexCallback = (windowWidth, slideCount) => {
            if (windowWidth > 960) {
                return Math.min(slideCount - 1, swiperNews.activeIndex + 3);
            } else if (windowWidth > 640) {
                return Math.min(slideCount - 1, swiperNews.activeIndex + 2);
            } else {
                return slideCount - 1;
            }
        };

        swiperNews.on('slideChange', () => updateOpacity(swiperNews, '.news .swiper-container .swiper-slide', newsEndIndexCallback));
        window.addEventListener('resize', () => updateOpacity(swiperNews, '.news .swiper-container .swiper-slide', newsEndIndexCallback));
        updateOpacity(swiperNews, '.news .swiper-container .swiper-slide', newsEndIndexCallback);
    }

    // slider Évènements
    const eventsSlideshow = document.querySelector('.home-events .swiper-container') !== null;

    if (eventsSlideshow) {
        let eventsSlides = document.querySelectorAll('.home-events .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let eventsConfig = {
            effect : 'slide',
            grabCursor : 'false',
            speed: 700,
            loop: false,

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                nextEl: `.home-events .swiper-button-next`,
                prevEl: `.home-events .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                1201: {
                    spaceBetween: 30,  
                    slidesPerView: 3,
                },
        
                961: {
                    spaceBetween: 20, 
                    slidesPerView: 3,
                },
                
                641: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                },
        
                0: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                }
            }
        }

        let swiperevents = new Swiper('.home-events .swiper-container', eventsConfig);

        // Fonction pour vérifier la taille de l'écran et le nombre de eventsSlides
        const postsNavigationEvents = document.querySelector('.home-events__navigation');

        function checkScreenSizeEvents() {
            const screenSizeEvents = window.innerWidth;
            const eventsSlides = document.querySelectorAll('.home-events .swiper-container .swiper-slide').length;

            if (screenSizeEvents > 960 && eventsSlides <= 3) {
                postsNavigationEvents.classList.add('disable');
            } else if (screenSizeEvents > 640 && eventsSlides <= 2) {
                postsNavigationEvents.classList.add('disable');
            } else if (screenSizeEvents <= 640 && eventsSlides <= 1) {
                postsNavigationEvents.classList.add('disable');
            } else {
                postsNavigationEvents.classList.remove('disable');
            }
        }

        checkScreenSizeEvents();

        window.addEventListener('resize', checkScreenSizeEvents);

        //Gestion de l'opacité des slides
        let eventsEndIndexCallback = (windowWidth, slideCount, activeIndex) => {
            if (windowWidth > 960) {
                return activeIndex + 2;  // Trois slides visibles (index actif + 2 suivants)
            } else if (windowWidth > 640) {
                return activeIndex + 1;  // Deux slides visibles (index actif + le suivant)
            } else {
                return activeIndex;  // Un seul slide visible
            }
        };
    
        swiperevents.on('slideChange', () => updateOpacity(swiperevents, '.home-events .swiper-container .swiper-slide', eventsEndIndexCallback));
        window.addEventListener('resize', () => updateOpacity(swiperevents, '.home-events .swiper-container .swiper-slide', eventsEndIndexCallback));
        updateOpacity(swiperevents, '.home-events .swiper-container .swiper-slide', eventsEndIndexCallback);
    
    }

    // Slider kiosque - Images
    const kiosqueImages = document.querySelector('.kiosque__right .swiper-container') !== null;
    let kiosqueAll = document.querySelectorAll('.kiosque__right .swiper-container .swiper-slide');
            
    if (kiosqueImages) {
        let kiosqueImagesSlides = document.querySelectorAll('.kiosque__right .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation, Autoplay, EffectCoverflow ]);

        let kiosqueImagesConfig = {
            effect: 'coverflow',
            loop: true,
            loopedSlides: 15,
            loopPreventsSliding: true,

            coverflowEffect: {
                scale: 0.95,
                rotate: 0,
                slideShadows: false,
            },

            keyboard: {
                enabled: true,
            },

            navigation: {
                prevEl: `.kiosque__navigation--prev`,
                nextEl: `.kiosque__navigation--next`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                1201: {
                    allowTouchMove: false,
                    coverflowEffect: {
                        depth: 170, //profondeur
                        stretch: 35, //écart
                    },
                },

                961: {
                    coverflowEffect: {
                        depth: 170,
                        stretch: 105,
                    },
                },

                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    effect : 'slide',
                    loop: false,
                    allowTouchMove: true,
                }
            }
        }

        // if(kiosqueImagesSlides > 1) {
            let swiperKiosqueImages = new Swiper('.kiosque__right .swiper-container', kiosqueImagesConfig);
        // }
    }
       

    // Slider kiosque - Content
    const kiosqueContent = document.querySelector('.kiosque .swiper-container__content') !== null;
            
    if (kiosqueContent) {
        let kiosqueContentSlides = document.querySelectorAll('.kiosque .swiper-container__content .swiper-slide').length;

        Swiper.use([ A11y, Navigation, Autoplay, EffectFade ]);

        let kiosqueContentConfig = {
            effect: 'fade',
            // loop: true,
            centeredSlides: true,

            keyboard: {
                enabled: true,
            },

            navigation: {
                prevEl: `.kiosque__navigation--prev`,
                nextEl: `.kiosque__navigation--next`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            slidesPerView: 1,
            spaceBetween: 0,

            breakpoints: {
                961: {
                    loop: true,
                    allowTouchMove: false,
                },
                0: {
                    loop: false,
                    allowTouchMove: true,
                }    
            }
        }

        // if (kiosqueContentSlides > 1) {
            let swiperKiosqueContent = new Swiper('.kiosque .swiper-container__content', kiosqueContentConfig);
        // }
    }

    // Slider projets
    const projetsSlideshow = document.querySelector('.projets .swiper-container') !== null;
            
    if (projetsSlideshow) {
        let projetsSlides = document.querySelectorAll('.projets .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation, EffectFade ]);

        let projetsConfig = {
            effect : 'fade',
            grabCursor : 'true',
            speed: 700,
            loop: false,
            slidesPerView: 'auto',

            keyboard: {
                enabled: true,
            },

            navigation: {
                prevEl: `.projets__navigation--prev`,
                nextEl: `.projets__navigation--next`,
            },

            slidesPerView: 1,
            spaceBetween: 30
        }

        if(projetsSlides > 1) {
            let swiperNews = new Swiper('.projets .swiper-container', projetsConfig);
        }
    }
}
